"use client"

import { useEffect, useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { getRandomThirdPartyCount } from "@/lib/utils"

const STORAGE_KEY = "cookie-consent"

export default function CookieConsent() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY)
    if (!consent) {
      setOpen(true)
    }
  }, [])

  const handleChoice = (value: "accepted" | "rejected") => {
    localStorage.setItem(STORAGE_KEY, value)
    setOpen(false)
  }

  return (
    <Dialog open={open}>
      <DialogContent
        className="sm:max-w-md [&>button]:hidden"
        // prevents closing via ESC or outside click
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>We use cookies 🍪</DialogTitle>
          <DialogDescription>
            We use cookies to improve your experience, analyze traffic,
            and personalize content. 
            <br />
            We sell all available device identifiers to train our AI models, 
            provide tracking for 63 world governments and to provide tailored advertisements.
            <br />
            You must choose whether to accept
            or reject {getRandomThirdPartyCount()} optional cookies before continuing.
          </DialogDescription>
        </DialogHeader>

        <div className="flex justify-end gap-2 pt-4">
          <Button
            variant="outline"
            onClick={() => handleChoice("rejected")}
          >
            Accept only optional
          </Button>

          <Button onClick={() => handleChoice("accepted")}>
            Accept all
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}